// src/Hook/Importazione/api.ts
import { postForm } from '../request';

export type Azione = 'aggiungi' | 'sostituisci';

export interface InviaImportazioneArgs {
  file: File;
  azione: Azione;  
  tipo: string;   
  negozio: string;   
  column?: string;
}

export interface ImportazioneResponse {
  message?: string;
}

export const inviaImportazione = ({ file, azione, tipo, negozio, column }: InviaImportazioneArgs) => {
  const form = new FormData();
  form.append('file', file);   
  form.append('azione', azione);
  form.append('tipo', tipo);
  form.append('negozio', negozio);
  if (column) form.append('column', column);

  return postForm<ImportazioneResponse>('import', form);
};
